import React from 'react';
import { UserIcon, BriefcaseIcon, LineChartIcon, LightbulbIcon, BarChart3Icon, HeartIcon } from 'lucide-react';
export function UserPersonaRole({
  data,
  updateData
}) {
  const roles = [{
    id: 'sales',
    title: 'Sales',
    icon: <BriefcaseIcon className="h-5 w-5" data-id="element-759" />,
    description: 'Focused on account fit, objections, and upsell opportunities',
    briefs: 'Sales-focused briefs with competitive analysis and objection handling'
  }, {
    id: 'consultant',
    title: 'Consultant',
    icon: <LightbulbIcon className="h-5 w-5" data-id="element-760" />,
    description: 'Focused on client pain points and transformation opportunities',
    briefs: 'Consulting-focused briefs with industry insights and solution frameworks'
  }, {
    id: 'executive',
    title: 'Executive',
    icon: <LineChartIcon className="h-5 w-5" data-id="element-761" />,
    description: 'Focused on strategic insights and high-level context',
    briefs: 'Executive-focused briefs with market trends and strategic opportunities'
  }, {
    id: 'product',
    title: 'Product Manager',
    icon: <BarChart3Icon className="h-5 w-5" data-id="element-762" />,
    description: 'Focused on user needs, roadmap alignment, and feature prioritization',
    briefs: 'Product-focused briefs with user feedback analysis and feature impact'
  }, {
    id: 'customer',
    title: 'Customer Success',
    icon: <HeartIcon className="h-5 w-5" data-id="element-763" />,
    description: 'Focused on customer health, retention, and expansion',
    briefs: 'Customer success-focused briefs with usage metrics and satisfaction indicators'
  }];
  const handleRoleSelect = roleId => {
    updateData('userRole', roleId);
  };
  return <div data-id="element-764">
      <h2 className="text-2xl font-bold mb-2" data-id="element-765">Select Your Role</h2>
      <p className="text-[#F5F7FA] text-opacity-70 mb-6" data-id="element-766">
        We'll tailor your meeting briefs based on your specific role and needs.
      </p>
      <div className="space-y-4" data-id="element-767">
        {roles.map(role => <div key={role.id} onClick={() => handleRoleSelect(role.id)} className={`flex items-start p-4 border rounded-lg cursor-pointer transition-all ${data.userRole === role.id ? 'border-[#C8F169] bg-[#C8F169] bg-opacity-5' : 'border-[#F5F7FA] border-opacity-10 hover:border-[#F5F7FA] hover:border-opacity-30'}`} data-id="element-768">
            <div className={`p-2 rounded-lg mr-4 ${data.userRole === role.id ? 'bg-[#C8F169] bg-opacity-20 text-[#C8F169]' : 'bg-[#F5F7FA] bg-opacity-10 text-[#F5F7FA]'}`} data-id="element-769">
              {role.icon}
            </div>
            <div className="flex-1" data-id="element-770">
              <h3 className="font-medium mb-1" data-id="element-771">{role.title}</h3>
              <p className="text-sm text-[#F5F7FA] text-opacity-70 mb-2" data-id="element-772">
                {role.description}
              </p>
              <div className="text-xs bg-[#1E2A38] p-2 rounded" data-id="element-773">
                <span className="text-[#C8F169]" data-id="element-774">You'll receive:</span>{' '}
                {role.briefs}
              </div>
            </div>
            <div className={`ml-4 h-5 w-5 rounded-full flex-shrink-0 ${data.userRole === role.id ? 'border-4 border-[#C8F169]' : 'border border-[#F5F7FA] border-opacity-30'}`} data-id="element-775"></div>
          </div>)}
      </div>
    </div>;
}